import type { ObjectDirective } from 'vue'

type ClickOutsideHandler = (event: MouseEvent | TouchEvent) => void

type ClickOutsideElement = HTMLElement & {
  __clickOutsideOnClick?: ClickOutsideHandler
}

const captureOpts = { capture: true }

const directive: ObjectDirective<ClickOutsideElement, ClickOutsideHandler> = {
  beforeMount (el, binding) {
    el.__clickOutsideOnClick = function (event: MouseEvent | TouchEvent) {
      if (!(el === event.target || el.contains(event.target as Node))) {
        binding.value(event)
      }
    }

    document.body.addEventListener('click', el.__clickOutsideOnClick, captureOpts)
    document.body.addEventListener('touchend', el.__clickOutsideOnClick, captureOpts)
  },

  unmounted (el) {
    if (!el.__clickOutsideOnClick) return

    document.body.removeEventListener('click', el.__clickOutsideOnClick, captureOpts)
    document.body.removeEventListener('touchend', el.__clickOutsideOnClick, captureOpts)
  },
}

export default directive
